/* ABCD Fashion — Halloween effects (Oct 2026): bats in the announcement bar, cobwebs, embers and
   bats in the hero. Pure decoration; everything is aria-hidden and off for reduced-motion users. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function el(cls) { var s = document.createElement('span'); s.className = cls; s.setAttribute('aria-hidden', 'true'); return s; }

  function bar() {
    var b = document.getElementById('section-announcement') || document.querySelector('.olyx-announce');
    if (!b || b.getAttribute('data-hw')) return;
    b.setAttribute('data-hw', '1');
    if (reduce) return;
    b.appendChild(el('hw-bat hw-bat--a'));
    b.appendChild(el('hw-bat hw-bat--b'));
  }

  function hero() {
    var h = document.querySelector('.HeroBanner__ImageWrapper');
    if (!h || h.getAttribute('data-hw')) return;
    h.setAttribute('data-hw', '1');
    h.appendChild(el('hw-web hw-web--l'));
    h.appendChild(el('hw-web hw-web--r'));
    if (reduce) return;
    var em = el('hw-embers');
    for (var i = 0; i < 18; i++) {
      var e = el('hw-ember');
      var sz = 3 + Math.random() * 5;
      e.style.left = (Math.random() * 100) + '%';
      e.style.width = e.style.height = sz.toFixed(1) + 'px';
      e.style.animationDuration = (6 + Math.random() * 7).toFixed(1) + 's';
      e.style.animationDelay = (-Math.random() * 12).toFixed(1) + 's';
      e.style.setProperty('--dx', (Math.random() * 90 - 45).toFixed(0) + 'px');
      em.appendChild(e);
    }
    h.appendChild(em);
    for (var j = 0; j < 3; j++) {
      var bt = el('hw-bat hw-bat--hero');
      bt.style.top = (6 + Math.random() * 42).toFixed(0) + '%';
      bt.style.animationDuration = (15 + j * 5) + 's';
      bt.style.animationDelay = (-j * 7) + 's';
      h.appendChild(bt);
    }
  }

  function heading() {
    var h = document.querySelector('#OlyxBS-abcd_rail_top .OlyxBS__Heading');
    if (!h || h.getAttribute('data-hw')) return;
    h.setAttribute('data-hw', '1');
    var p = el('hw-pumpkin'); p.textContent = '🎃 ';
    h.insertBefore(p, h.firstChild);
  }

  function run() { bar(); hero(); heading(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
